import { render, staticRenderFns } from "./MMP_AppLogo.vue?vue&type=template&id=67cc3af6&scoped=true&"
import script from "./MMP_AppLogo.vue?vue&type=script&lang=js&"
export * from "./MMP_AppLogo.vue?vue&type=script&lang=js&"
import style0 from "./MMP_AppLogo.vue?vue&type=style&index=0&id=67cc3af6&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67cc3af6",
  null
  
)

export default component.exports